import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, PlusCircle } from "lucide-react";

/**
 * 🆕 Feb 2026 — Pagina di conferma invio offerta partner.
 *
 * Volutamente statica e senza alcuna manipolazione DOM post-mount:
 * nessun Dialog Radix, nessun portal, nessun side-effect su `document.body`.
 * Viene raggiunta via `window.location.href` dopo un POST riuscito su
 * `/api/public/partner-offer/{token}` — in questo modo la pagina del form
 * (con il suo albero React) viene completamente smontata dal browser
 * prima che compaia questa conferma, azzerando qualunque possibile
 * conflitto di reconciliation (errori `removeChild`/`nodeType`).
 */
export default function OfferSent() {
  const [params] = useSearchParams();
  const token = (params.get("token") || "").trim();
  const company = (params.get("company") || "").trim();
  const frazionamento = (params.get("frazionamento") || "").trim();

  const backToForm = token ? `/inserisci-offerta/${token}` : null;

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-teal-50 p-4"
      data-testid="offer-sent-page"
    >
      <div className="max-w-lg w-full bg-white rounded-lg shadow-xl p-8 border-2 border-emerald-300">
        <div className="text-center">
          <CheckCircle2 className="h-16 w-16 text-emerald-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-slate-800 mb-2" data-testid="offer-sent-title">
            Offerta inviata!
          </h1>
          <p className="text-sm text-slate-600">
            L'agenzia ha ricevuto la tua proposta e ti ricontatterà a breve.
          </p>
          {(company || frazionamento) && (
            <p className="text-xs text-slate-500 mt-2" data-testid="offer-sent-meta">
              {company && <>Compagnia: <strong>{company}</strong></>}
              {company && frazionamento && " · "}
              {frazionamento && <>Frazionamento: <strong>{frazionamento}</strong></>}
            </p>
          )}
        </div>

        {backToForm && (
          <div className="mt-6 border-t border-slate-200 pt-5 flex flex-col sm:flex-row gap-2">
            <Link
              to={backToForm}
              className="inline-flex items-center justify-center gap-2 flex-1 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium px-4 py-2 transition-colors"
              data-testid="offer-sent-new-offer-link"
            >
              <PlusCircle className="h-4 w-4" /> Invia un'altra offerta
            </Link>
          </div>
        )}

        <p className="text-[11px] text-slate-400 mt-6 text-center">
          Puoi chiudere questa pagina in sicurezza.
        </p>
      </div>
    </div>
  );
}
